import { GET_RESE_STORE_TABLE_DATA, GET_RESE_STORE_TABLE_DIVISION, GET_RESE_STORE_TABLE_BANNER,
GET_RESE_STORE_TABLE_CITY, GET_RESE_STORE_TABLE_STATE, GET_RESE_STORE_TABLE_STATUS, UPDATE_RESE_STORE_TABLE_DATA } from "./actionTypes";

export const getReseStoreTableDataInit = (pageNumber, pageSize, sortBy, sortDirection, filterCondition) => ({
    type: GET_RESE_STORE_TABLE_DATA.INIT,
    pageNumber, pageSize, sortBy, sortDirection, filterCondition
});

export const getReseStoreTableDataSuccess = (storeTableData) => ({
    type: GET_RESE_STORE_TABLE_DATA.SUCCESS,
    payload: storeTableData
});

export const getReseStoreTableDataError = (error) => ({
    type: GET_RESE_STORE_TABLE_DATA.ERROR,
    payload: error
});

export const getReseStoreTableDivisionInit = (divisionColumnPayload) => ({
    type: GET_RESE_STORE_TABLE_DIVISION.INIT,
    divisionColumnPayload
});

export const getReseStoreTableDivisionSuccess = (divisionData) => ({
    type: GET_RESE_STORE_TABLE_DIVISION.SUCCESS,
    payload: divisionData
});

export const getReseStoreTableDivisionError = (error) => ({
    type: GET_RESE_STORE_TABLE_DIVISION.ERROR,
    payload: error
});

export const getReseStoreTableBannerInit = (bannerColumnPayload) => ({
    type: GET_RESE_STORE_TABLE_BANNER.INIT,
    bannerColumnPayload
});

export const getReseStoreTableBannerSuccess = (bannerData) => ({
    type: GET_RESE_STORE_TABLE_BANNER.SUCCESS,
    payload: bannerData
});

export const getReseStoreTableBannerError = (error) => ({
    type: GET_RESE_STORE_TABLE_BANNER.ERROR,
    payload: error
});

export const getReseStoreTableCityInit = (cityColumnPayload) => ({
    type: GET_RESE_STORE_TABLE_CITY.INIT,
    cityColumnPayload
});

export const getReseStoreTableCitySuccess = (cityData) => ({
    type: GET_RESE_STORE_TABLE_CITY.SUCCESS,
    payload: cityData
});

export const getReseStoreTableCityError = (error) => ({
    type: GET_RESE_STORE_TABLE_CITY.ERROR,
    payload: error
});

export const getReseStoreTableStateInit = (stateColumnPayload) => ({
    type: GET_RESE_STORE_TABLE_STATE.INIT,
    stateColumnPayload
});

export const getReseStoreTableStateSuccess = (stateData) => ({
    type: GET_RESE_STORE_TABLE_STATE.SUCCESS,
    payload: stateData
});

export const getReseStoreTableStateError = (error) => ({
    type: GET_RESE_STORE_TABLE_STATE.ERROR,
    payload: error
});

export const getReseStoreTableStatusInit = (statusColumnPayload) => ({
    type: GET_RESE_STORE_TABLE_STATUS.INIT,
    statusColumnPayload
});

export const getReseStoreTableStatusSuccess = (statusData) => ({
    type: GET_RESE_STORE_TABLE_STATUS.SUCCESS,
    payload: statusData
});

export const getReseStoreTableStatusError = (error) => ({
    type: GET_RESE_STORE_TABLE_STATUS.ERROR,
    payload: error
});

export const updateReseStoreTableDataInit = (tableData) => ({
    type: UPDATE_RESE_STORE_TABLE_DATA.INIT,
    tableData
});

export const updateReseStoreTableDataSuccess = (updatedData) => ({
    type: UPDATE_RESE_STORE_TABLE_DATA.SUCCESS,
    payload: updatedData
});

export const updateReseStoreTableDataError = (error) => ({
    type: UPDATE_RESE_STORE_TABLE_DATA.ERROR,
    payload: error
});